import { defineMessages } from 'react-intl';

export const messages: {
	invalidEmail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	invalidEmail: {
		id: 'proforma-form-renderer.common.utils.validators.email.invalid-email',
		defaultMessage: 'Must be an email address',
		description: 'Validation message for field with invalid email.',
	},
});
